var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardChipIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_540_4901)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 15.5768C22.0001 16.0266 21.9188 16.4721 21.7608 16.8877C21.6029 17.3033 21.3713 17.6809 21.0794 17.9989C20.7875 18.3169 20.4409 18.5692 20.0595 18.7412C19.6782 18.9132 19.2694 19.0017 18.8566 19.0015H3.14157C2.7289 19.0016 2.32026 18.9131 1.93899 18.741C1.55773 18.569 1.21132 18.3167 0.919562 17.9986C0.627805 17.6806 0.396421 17.303 0.238638 16.8874C0.0808541 16.4719 -0.000236425 16.0265 5.17755e-07 15.5768V3.42467C-0.000117902 2.97498 0.0810542 2.52967 0.23888 2.11418C0.396705 1.69868 0.628093 1.32114 0.919826 1.00312C1.21156 0.685098 1.55792 0.432825 1.93914 0.260707C2.32035 0.0885895 2.72894 1.67215e-08 3.14157 3.52398e-08H18.8566C19.2694 -6.44843e-05 19.6781 0.0884671 20.0594 0.260538C20.4407 0.432608 20.7873 0.684849 21.0791 1.00286C21.371 1.32087 21.6026 1.69842 21.7606 2.11395C21.9186 2.52949 21.9999 2.97487 22 3.42467V15.5768Z",
    fill: "url(#paint0_linear_540_4901)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M22.0005 5.98715V5.54893H17.9704V0H17.5683V5.55139H14.3032C14.0914 4.81284 13.6841 4.15893 13.1325 3.67175C12.5809 3.18457 11.9095 2.88583 11.2026 2.81303V0H10.7969V2.78257C10.0391 2.79875 9.3052 3.07474 8.69949 3.57133C8.09378 4.06793 7.64705 4.75989 7.42274 5.54893H4.45923V0H4.05713V5.55139H0V5.98961H4.05713V12.2032H0V12.6424H4.05713V18.9995H4.45923V12.6424H7.33889C7.51966 13.4998 7.95815 14.2667 8.58469 14.8213C9.21123 15.3759 9.98988 15.6865 10.7969 15.7036V18.9995H11.2026V15.6751C11.9585 15.5985 12.673 15.2646 13.2449 14.7206C13.8168 14.1766 14.217 13.4502 14.3888 12.6444H17.5701V19.0015H17.9722V12.6424H22.0023V12.2032H19.5973V5.98715H22.0005ZM7.28299 12.2032H4.45923V5.98715H7.30914C7.26577 6.22915 7.24313 6.47503 7.24152 6.7216C7.2437 7.64497 7.54496 8.53785 8.09217 9.24282C7.75992 9.6369 7.51451 10.1084 7.3746 10.6214C7.2347 11.1344 7.20398 11.6754 7.2848 12.2032H7.28299ZM10.8627 15.2722C10.2367 15.2747 9.62377 15.0774 9.09937 14.7049C8.57497 14.3323 8.16205 13.8007 7.91152 13.1755C7.66098 12.5503 7.58377 11.8589 7.6894 11.1864C7.79503 10.514 8.07889 9.88995 8.50599 9.39118L8.63131 9.2438L8.50599 9.09642C8.07909 8.59629 7.79544 7.97122 7.68986 7.29792C7.58427 6.62462 7.66135 5.93237 7.91163 5.30612C8.1619 4.67988 8.57449 4.14688 9.09876 3.77253C9.62303 3.39818 10.2362 3.19877 10.863 3.19877C11.4897 3.19877 12.1029 3.39818 12.6272 3.77253C13.1514 4.14688 13.564 4.67988 13.8143 5.30612C14.0646 5.93237 14.1416 6.62462 14.0361 7.29792C13.9305 7.97122 13.6468 8.59629 13.2199 9.09642L13.0933 9.2438L13.2199 9.39118C13.6468 9.89006 13.9305 10.5141 14.036 11.1865C14.1415 11.8589 14.0642 12.5503 13.8137 13.1754C13.5631 13.8005 13.1503 14.3321 12.6259 14.7047C12.1016 15.0773 11.4887 15.2745 10.8627 15.2722ZM19.1952 12.2032H14.4429C14.5239 11.6755 14.4934 11.1345 14.3538 10.6215C14.2141 10.1086 13.9689 9.63703 13.6369 9.24282C14.1835 8.53758 14.4841 7.64472 14.4857 6.7216C14.4841 6.47503 14.4615 6.22915 14.4181 5.98715H19.1965L19.1952 12.2032Z",
    fill: "url(#paint1_linear_540_4901)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_540_4901",
    x1: 11.0002,
    y1: -5.11563,
    x2: 11.0002,
    y2: 42.8218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CA7C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FDDB7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FFAD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#A95F0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFAD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FFFF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FFED7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_540_4901",
    x1: 11.0007,
    y1: -16.7347,
    x2: 11.0007,
    y2: 43.2866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CA7C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FDDB7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FFAD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#A95F0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFAD45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FFFF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FFED7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA3F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_540_4901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardChipIcon);
export default __webpack_public_path__ + "static/media/CardChipIcon.b0369ca86e54be3774ea2e6ae33d7f79.svg";
export { ForwardRef as ReactComponent };